import { render } from "./leaves-employee.vue?vue&type=template&id=21ac91cc"
import script from "./leaves-employee.vue?vue&type=script&lang=js"
export * from "./leaves-employee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__